// extracted by mini-css-extract-plugin
export var navbarSubLink = "K_f6 d_f6 d_f0 d_X d_b8 d_dj d_bp d_bQ";
export var menuLink = "K_tC d_fX d_dx";
export var subPageLink = "K_gb d_gb d_dn d_dr";
export var subPageLinkColor = "K_gc d_gc";
export var burgerItemSmall = "K_tD d_f9 d_W d_bq";
export var Link = "K_ss x_ss x_rN x_r6";